<template>
  <div
    class="pointer-events-none fixed bottom-0 z-30 flex h-auto w-full max-w-xl justify-center"
  >
    <div
      class="pointer-events-auto absolute bottom-20 mr-5 h-auto transform rounded-lg border-2 border-kekkle-blue-dark bg-kekkle-blue-light p-1 shadow-blue-hard-sm transition-all duration-500 ease-in-out hover:translate-y-1 hover:bg-kekkle-blue hover:shadow-none"
      :class="
        $route.name === 'Agenda'
          ? 'right-0 opacity-100'
          : 'right-0 translate-x-full opacity-0'
      "
      @click="goToAddEvents()"
    >
      <div
        class="align-center flex flex-row content-center items-center justify-center gap-x-2 px-2 py-1"
      >
        <p class="text-md h-min text-kekkle-blue-dark">
          {{ $t("components.navigation.add_event") }}
        </p>
        <plus-icon class="w-5 text-kekkle-blue-dark"></plus-icon>
      </div>
    </div>
    <div
      class="pointer-events-auto absolute bottom-20 mr-5 h-auto transform rounded-lg border-2 border-kekkle-red-dark bg-kekkle-red-light p-1 shadow-red-hard-sm transition-all duration-500 ease-in-out hover:translate-y-1 hover:bg-kekkle-red hover:shadow-none"
      :class="
        $route.name === 'Quotes' || $route.name === 'QuotesWithAuthor'
          ? 'right-0 opacity-100'
          : 'right-0 translate-x-full opacity-0'
      "
      @click="goToAddQuotes()"
    >
      <div
        class="align-center flex flex-row content-center items-center justify-center gap-x-2 px-2 py-1"
      >
        <p class="text-md h-min text-kekkle-red-dark">
          {{ $t("components.navigation.add_quote") }}
        </p>
        <plus-icon class="w-5 text-kekkle-red-dark"></plus-icon>
      </div>
    </div>
    <div
      class="pointer-events-auto absolute bottom-20 mr-5 h-auto transform rounded-lg border-2 border-kekkle-purple-dark bg-kekkle-purple-light p-1 shadow-purple-hard-sm transition-all duration-500 ease-in-out hover:translate-y-1 hover:bg-kekkle-purple hover:shadow-none"
      :class="
        $route.name === 'Photos'
          ? 'right-0 opacity-100'
          : 'right-0 translate-x-full opacity-0'
      "
      @click="goToAddPhotos()"
    >
      <div
        class="align-center flex flex-row content-center items-center justify-center gap-x-2 px-2 py-1"
      >
        <p class="text-md h-min text-kekkle-purple-dark">
          {{ $t("components.navigation.add_photo") }}
        </p>
        <plus-icon class="w-5 text-kekkle-purple-dark"></plus-icon>
      </div>
    </div>
    <div
      class="pointer-events-auto absolute bottom-20 mr-5 h-auto transform rounded-lg border-2 border-kekkle-yellow-dark bg-kekkle-yellow-light p-1 shadow-yellow-hard-sm transition-all duration-500 ease-in-out hover:translate-y-1 hover:bg-kekkle-yellow hover:shadow-none"
      :class="
        $route.name === 'Shorts'
          ? 'right-0 opacity-100'
          : 'right-0 translate-x-full opacity-0'
      "
      @click="goToAddShort()"
    >
      <div
        class="align-center flex flex-row content-center items-center justify-center gap-x-2 px-2 py-1"
      >
        <p class="text-md h-min font-medium text-black-dark">
          {{ $t("pages.shorts.record_short") }}
        </p>
        <plus-icon class="w-5 text-black-dark"></plus-icon>
      </div>
    </div>
    <!--  the bar-->
    <div
      class="pointer-events-auto flex w-full flex-nowrap items-center justify-between gap-x-2 border-t-2 border-kekkle-dark bg-white px-4 pt-2 pb-4 sm:px-6 dark:border-kekkle-dark-light dark:bg-kekkle-dark-dark"
    >
      <router-link
        :to="{ name: 'Agenda' }"
        :class="
          $route.name === 'Agenda'
            ? 'w-12 translate-y-1 bg-kekkle-blue p-1 text-white shadow-none dark:text-kekkle-dark-dark'
            : 'w-10 p-2 text-kekkle-blue shadow-blue-hard-sm'
        "
        class="h-10 rounded-lg border-2 border-kekkle-blue transition-all duration-200"
        exact
      >
        <div class="flex h-full items-center justify-center gap-x-2">
          <CalendarIcon class="h-full" />
        </div>
      </router-link>
      <router-link
        :to="{ name: 'Quotes' }"
        :class="
          $route.name === 'Quotes' || $route.name === 'QuotesWithAuthor'
            ? 'w-12 translate-y-1 bg-kekkle-red p-1 text-white shadow-none dark:text-kekkle-dark-dark'
            : 'w-10 p-2 text-kekkle-red shadow-red-hard-sm'
        "
        class="h-10 rounded-lg border-2 border-kekkle-red transition-all duration-200"
        exact
      >
        <div class="flex h-full items-center justify-center gap-x-2">
          <SpeakerphoneIcon class="h-full" />
        </div>
      </router-link>
      <router-link
        :to="{ name: 'Photos' }"
        :class="
          $route.name === 'Photos'
            ? 'w-12 translate-y-1 bg-kekkle-purple p-1 text-white shadow-none dark:text-kekkle-dark-dark'
            : 'w-10 p-2 text-kekkle-purple shadow-purple-hard-sm'
        "
        class="h-10 rounded-lg border-2 border-kekkle-purple transition-all duration-200"
        exact
      >
        <div class="flex h-full items-center justify-center gap-x-2">
          <CameraIcon class="h-full" />
        </div>
      </router-link>
      <router-link
        :to="{ name: 'Shorts' }"
        :class="
          $route.name === 'Shorts'
            ? 'w-12 translate-y-1 bg-kekkle-yellow p-1 text-white shadow-none dark:text-kekkle-dark-dark'
            : 'w-10 p-2 text-kekkle-yellow shadow-yellow-hard-sm'
        "
        class="h-10 rounded-lg border-2 border-kekkle-yellow transition-all duration-200"
        exact
      >
        <div class="flex h-full items-center justify-center gap-x-2">
          <FilmIcon class="h-full" />
        </div>
      </router-link>
      <router-link
        :to="{ name: 'Games' }"
        :class="
          $route.name === 'Games'
            ? 'w-12 translate-y-1 bg-kekkle-yellow p-1 text-white shadow-none dark:text-kekkle-dark-dark'
            : 'w-10 p-2 text-kekkle-yellow shadow-yellow-hard-sm'
        "
        class="h-10 rounded-lg border-2 border-kekkle-yellow transition-all duration-200"
        exact
      >
        <div class="flex h-full items-center justify-center gap-x-2">
          <PuzzleIcon class="h-full" />
        </div>
      </router-link>

      <router-link
        :to="{ name: 'Group' }"
        class="relative h-10 rounded-lg border-2 border-kekkle-dark bg-kekkle-red shadow-dark-hard-sm transition-all duration-300"
        :class="
          $route.name === 'Group'
            ? 'shadow-none-important w-12 translate-y-1'
            : 'w-10'
        "
        @touchstart.prevent="handleGroupTouchStart"
        @touchend.prevent="handleGroupTouchEnd"
        @mousedown.prevent="handleGroupMouseDown"
        @mouseup.prevent="handleGroupMouseUp"
        @mouseleave="cancelLongPress"
      >
        <transition name="opacity"
          ><img
            v-if="pictureUrl"
            alt="group picture"
            class="h-full w-full rounded-sm object-cover"
            :src="pictureUrl"
          />
          <img
            v-else-if="!pictureUrl && blurUrl"
            alt="group picture blur"
            draggable="false"
            class="z-20 mx-auto h-full rounded-sm object-contain"
            :src="blurUrl"
          />
        </transition>
      </router-link>
    </div>

    <!-- Group Selector Bottom Sheet -->
    <group-selector-bottom-sheet
      v-model:open="groupSelectorBottomSheetOpen"
    ></group-selector-bottom-sheet>
  </div>
</template>

<script lang="ts">
import {
  CalendarIcon,
  PlusIcon,
  SpeakerphoneIcon,
  CameraIcon,
  FilmIcon,
  PuzzleIcon,
} from "@heroicons/vue/outline";
import { ImageSizes } from "@/enums/images-sizes";
import { useGroupsStore } from "@/stores/modules/groups/groups";
import { decodeBlurhashToUrl } from "@/helpers/blurhash/decodeBlurhashToUrl";
import { useUserStore } from "@/stores/modules/user/user";
import GroupSelectorBottomSheet from "@/components/GroupSelectorBottomSheet.vue";
import { useQuoteManagement } from "@/composables/useQuoteManagement";
import { usePhotoManagement } from "@/composables/usePhotoManagement";
import { useEventManagement } from "@/composables/useEventManagement";
import { useShortManagement } from "@/composables/useShortManagement";

export default {
  name: "NavigationBar",
  components: {
    CalendarIcon,
    PlusIcon,
    SpeakerphoneIcon,
    CameraIcon,
    FilmIcon,
    PuzzleIcon,
    GroupSelectorBottomSheet,
  },
  setup() {
    const groupsStore = useGroupsStore();
    const userStore = useUserStore();
    const { openAddQuoteBottomSheet } = useQuoteManagement();
    const { openAddPhotoBottomSheet } = usePhotoManagement();
    const { openAddEventBottomSheet } = useEventManagement();
    const { triggerRecordShort } = useShortManagement();
    return {
      groupsStore,
      userStore,
      openAddQuoteBottomSheet,
      openAddPhotoBottomSheet,
      openAddEventBottomSheet,
      triggerRecordShort,
    };
  },
  data() {
    return {
      blurUrl: null as string | null,
      groupSelectorBottomSheetOpen: false,
      longPressTimer: null as ReturnType<typeof setTimeout> | null,
      longPressTriggered: false,
    };
  },
  computed: {
    selectedGroup() {
      return this.userStore.activeGroup;
    },
    groupPictureData() {
      return this.groupsStore.activeGroupPictureData;
    },
    pictureUrl() {
      return this.groupPictureData?.[ImageSizes.Thumb]?.url;
    },
  },
  watch: {
    selectedGroup() {
      // Fetch picture data for the new group
      this.groupsStore.downloadGroupPictureData(ImageSizes.Thumb);
      // Update blurhash
      this.blurUrl = decodeBlurhashToUrl(this.groupPictureData?.blurhash);
    },
  },
  created() {
    // Check if there's already a URL, if not fetch it
    this.groupsStore.downloadGroupPictureData(ImageSizes.Thumb);
    // Set blurhash
    this.blurUrl = decodeBlurhashToUrl(this.groupPictureData?.blurhash);
  },
  methods: {
    goToAddEvents() {
      if (this.$route.name === "Agenda") {
        this.openAddEventBottomSheet();
      }
    },
    goToAddQuotes() {
      if (
        this.$route.name === "Quotes" ||
        this.$route.name === "QuotesWithAuthor"
      ) {
        this.openAddQuoteBottomSheet();
      }
    },
    goToAddPhotos() {
      if (this.$route.name === "Photos") {
        this.openAddPhotoBottomSheet();
      }
    },
    goToAddShort() {
      if (this.$route.name === "Shorts") {
        this.triggerRecordShort();
      }
    },
    handleGroupTouchStart() {
      this.longPressTriggered = false;
      this.longPressTimer = setTimeout(() => {
        this.longPressTriggered = true;
        this.groupSelectorBottomSheetOpen = true;
      }, 500); // 500ms for long press
    },
    handleGroupTouchEnd() {
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }

      // Only navigate if it wasn't a long press
      if (!this.longPressTriggered) {
        this.$router.push({ name: "Group" });
      }
    },
    handleGroupMouseDown() {
      this.longPressTriggered = false;
      this.longPressTimer = setTimeout(() => {
        this.longPressTriggered = true;
        this.groupSelectorBottomSheetOpen = true;
      }, 500); // 500ms for long press
    },
    handleGroupMouseUp() {
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }

      // Only navigate if it wasn't a long press
      if (!this.longPressTriggered) {
        this.$router.push({ name: "Group" });
      }
    },
    cancelLongPress() {
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }
      this.longPressTriggered = false;
    },
  },
};
</script>

<style>
.opacity-enter-active {
  transition: all 1s;
  transition-timing-function: ease;
}

.opacity-leave-active {
  position: absolute;
  transition: all 1s;
  transition-timing-function: ease;
}
.opacity-enter, .opacity-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transition: all 1s;
}
</style>
